<template>
  <div>
    <v-dialog
      v-model="active"
      persistent
      scrollable
      max-width="800px">
      <validation-observer
        ref="code-obs"
        tag="form"
        @submit.prevent="onSubmit">
        <v-card>
          <v-card-title class="primary">
            <code class="code-title">สร้างรหัสโค้ดส่วนลด</code>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row class="pl-5">
                <code-type-field
                  :old-code="oldCode.code"
                  :editable="editable"
                  :action="action"
                  @input="bindValue" />
                <code-condition
                  :old-code="oldCode"
                  :action="action"
                  :discount-types="list.discountTypes"
                  class="code-conditioner-modal"
                  :editable="editable"
                  @input="bindValue" />
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              text
              @click="closeModal">
              Close
            </v-btn>
            <v-btn
              type="submit"
              color="success">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </validation-observer>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CodeCondition from './CodeCondition.vue'
import CodeTypeField from './CodeTypeField.vue'

export default {
  components: {
    CodeTypeField,
    CodeCondition
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    oldCode: {
      type: Object,
      default: () => {}
    },
    editable: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      form: {},
      list: {
        discountTypes: [
          { text: 'บาท', value: 'amount' },
          { text: '%', value: 'percentage' }
        ]
      },
      codeDetail: {}
    }
  },
  watch: {
    oldCode: {
      handler () {
        this.codeDetail = this.oldCode
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar',
      setModal: 'Style/setModal'
    }),
    bindValue (val) {
      this.form = {
        ...this.form,
        ...val
      }
    },
    closeModal () {
      this.$emit('close-modal', false)
    },
    async onSubmit () {
      const isValid = await this.$refs['code-obs'].validate()
      if (isValid) {
        this.codeDetail = this.reformCodeDetail(this.form)
        this.$emit('input', this.codeDetail)
        this.setSnackBar({
          value: true,
          message: 'บันทึกรายละเอียดโค้ดส่วนลดแล้ว',
          type: 'success'
        })

        this.closeModal()
      } else {
        this.setSnackBar({
          value: true,
          message: 'ไม่สามารถสร้างโค้ดส่วนลดนี้ได้',
          type: 'error'
        })
      }
    },
    reformCodeDetail (form) {
      const processedCode = {}
      Object.keys(form).forEach((key) => {
        if (form[key].enable) {
          processedCode[key] = form[key].value
        }
      })

      return processedCode
    }
  }
}
</script>

<style scoped>
.code-title {
  font-size: 24px;
  color: black;
}
</style>
